module.exports = __webpack_public_path__ + "assets/img/frame-winner.c1cf377e.png";